export default "https://cdn-static.gokick.com/assets/f142aa9afb455fb94cf2718539e479c66bf8a410/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";